module.exports = __webpack_public_path__ + "img/9788952761323.9643c986.jpg";